import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNintendogamecubeComponent } from './simple-icons-nintendogamecube.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNintendogamecubeComponent ],
    exports:      [ SimpleIconsNintendogamecubeComponent ],
    bootstrap:    []
})
export class SimpleIconsNintendogamecubeModule {}
